import { useState, useEffect, useCallback } from 'react';
import API from 'api/api';
import { useAuth } from 'contexts/AuthContext';
import { normalizeListingList } from '../utils/normalizeListing';

/**
 * Hook to fetch completed listings for the currently authenticated partner.
 * Uses the GET /api/users/:id/completed-bookings endpoint.
 */
export const useGetPartnerCompletedListings = () => {
  const { user } = useAuth();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchListings = useCallback(async () => {
    // If we don't have a user UID yet (Firebase still initializing), skip
    if (!user?.uid) {
      return;
    }

    setLoading(true);
    try {
      const response = await API.get(`/users/${user.uid}/completed-bookings`);
      
      // The response.data should be the list of listings
      const data = response.data;
      const normalized = Array.isArray(data) 
        ? normalizeListingList(data) 
        : (Array.isArray(data?.listings) ? normalizeListingList(data.listings) : []);
        
      setListings(normalized);
      setError(null);
    } catch (err) {
      console.error('[useGetPartnerCompletedListings] Error:', err);
      setError(err.message || 'Failed to load completed listings');
    } finally {
      setLoading(false);
    }
  }, [user?.uid]);

  useEffect(() => {
    fetchListings();
  }, [fetchListings]);

  return {
    listings,
    loading,
    error,
    refresh: fetchListings
  };
};

export default useGetPartnerCompletedListings;
